module.exports = __webpack_public_path__ + "media/images/lock_grey-1b8f062adc4e81de149cbf65e15edf33.svg";